import React, { useEffect, useState } from "react";
import { IonContent, IonPage} from '@ionic/react';
import Header from "../components/Header";
import './Services.css';
import Footer from "../components/Footer";
import ReactGA from "react-ga4";

interface props {
    netState: boolean
}
// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/Services',
//       page_title: 'Services'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });  
        
//     ReactGA.initialize("G-QMKE0236CC");
//     ReactGA.send({ hitType: "pageview", page: "/pages/Services", title: "Soluciones" });

const Services: React.FC<props> = ({netState}) => {
    
    
    if(netState)
    return(
        <IonPage className="no-barra">
            <Header pageName="Nuestras Soluciones"/>
            <iframe className="frame-soluciones" src="https://mastinseguridad.com/soluciones/?utm_source=app_movil&utm_medium=servicios&utm_campaign=2022_06_03%20servicios%20generales" frameBorder="0"></iframe>
        </IonPage>
    );
    else {
        return(
        <IonPage className="no-barra">
            <Header pageName="Nuestras Soluciones"/>
            <IonContent className="pqrs-content" id="pqrs">
                <h3 className="disconnect">¡Compruebe su conexión de internet!</h3>
            </IonContent>
                <Footer />
        </IonPage>
        );
    }
   
}

export default Services;